import React, { Component, ErrorInfo } from 'react';
import { Modal } from 'antd';
import { msalInstance } from '../main';

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
}

class SessionErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Session error:', error, errorInfo);
  }

  private handleRefresh = () => {
    window.location.reload();
  };

  private handleRelogin = async () => {
    await msalInstance.logoutRedirect();
  };

  public render() {
    if (this.state.hasError) {
      return (
        <Modal
          title="Session Error"
          open={true}
          onOk={this.handleRefresh}
          onCancel={this.handleRelogin}
          okText="Refresh Page"
          cancelText="Re-login"
        >
          <p>
            Your session has expired or encountered an error. Please refresh the
            page or login again.
          </p>
        </Modal>
      );
    }

    return this.props.children;
  }
}

export default SessionErrorBoundary;
